import React from 'react';
import styled from 'styled-components';

import Container from 'react-bootstrap/Container'
import { graphql, useStaticQuery } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import Img from "gatsby-image";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Face from '../images/facebook.svg';
import Inst from '../images/instagram.svg';
import Yout from '../images/youtube.svg';
import Link from '../images/indeed.svg';


//Responsive
import { device } from "../utils/breakpoints"
import { anims, colors } from "../utils/theme"

const FooterBar = styled.footer`
    background: #1a1a1a;
    padding: 2rem 0;
    color: white;
    & img{
        @media (max-width: 768px) {
            margin: 0 auto;
            display: block;
        }
    }
    @media (max-width: 768px) {
        & .text-right{
            text-align: center !important;
        }
        & a{
            display: inline-block;
        }
        & .logo-link{
            display: block;
            padding: 1rem 0;
        }
    }
    
    & .social-media-icon{
        width: 23px;
        height: 23px;
        margin: 0 .3em;
        
    }
    & .social{
        text-align: right;
        @media (max-width: 768px) {
            text-align: center;
        }
    }
`;

const Logo = styled(BackgroundImage)`
    width: 180px;
    height: 60px;
    margin: 0 auto;
    background-position: top center;
    background-repeat: none;
    background-size: 100% auto;
`;

const Footer = () => {
    const { image } = useStaticQuery(graphql`
        query{
            image: file(relativePath: { eq:"logo-footer.webp"}){
                sharp: childImageSharp{
                    fluid(quality: 90, maxWidth: 220){
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `);

    return (
        <FooterBar>
            <Container>
                <Row>
                    <Col md={3}>
                        <Logo
                            tag="div"
                            fluid={image.sharp.fluid}
                            fadeIn="soft"
                        >
                        </Logo>
                    </Col>
                    <Col md={9} className="social">
                        <span>Siguenos: </span>
                        <a href="https://www.facebook.com/libelacademy" target="_blank">
                                <img src={Face} alt="" className="social-media-icon" />
                            </a>
                            <a href="https://www.instagram.com/libelacademy/" target="_blank">
                                <img src={Inst} alt="" className="social-media-icon" />
                            </a>
                            <a href="https://www.youtube.com/channel/UCUgle_FMVoBU75h0Vx8L7xA" target="_blank" >
                                <img src={Yout} alt="" className="social-media-icon"/>
                            </a>
                            <a href="https://co.linkedin.com/company/libelstudios" target="_blank">
                                <img src={Link} alt="" className="social-media-icon"/>
                            </a>
                    </Col>
                </Row>
            </Container>
        </FooterBar>
    );
}

export default Footer;